import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface StyleProps {
  notDueToday?: boolean
  fullWidth?: boolean
}
const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  title: {
    width: ({ fullWidth }) => (fullWidth ? '100%' : '45%'),

    '& > :first-child > :first-child': {
      color: ({ notDueToday }) =>
        notDueToday
          ? theme.palette.indicator.green
          : theme.palette.indicator.orange
    },

    [theme.breakpoints.down('lg')]: {
      width: '100% !important'
    }
  }
}))

export default useStyles
